import React, { Component } from 'react';
import TypeIt from 'typeit';

class Type extends Component {
  componentDidMount() {
    new TypeIt(this.el, this.props);
  }

  render() {
    return (
      <span
        ref={el => {
          this.el = el;
        }}
      >
        {this.props.children}
      </span>
    );
  }
}

export default Type;



// WEBPACK FOOTER //
// ./src/components/Type.js